import React from "react";
import "./pageLoadingShimmer.css";

const PageLoadingShimmer = () => {
  return <div className="page_loading_shimmer"></div>;
};

export default PageLoadingShimmer;
